/* Cart lines: a padlock and its option companions move together (Sam, 2026-09-22).
 *
 * Paid options (numbering, keys) are companion lines of the CHF 1 unit product carrying
 * `_config_parent` (the padlock's line key) and `_config_unit` (CHF per padlock). Athens'
 * CartItems changes ONE line per request (/cart/change.js by line index), and the companion was
 * then corrected afterwards by cart-surcharge-sync.js — one request late, with a flash of the
 * old total, and not at all on a remove (that path dispatches an event the sync did not hear).
 *
 * This wraps CartItems.updateQuantity: when the row carries companions (sections/dc-main-cart
 * .liquid writes `data-key` and `data-companions="key=unit|…"`), the padlock and every companion
 * are re-quantified in ONE /cart/update.js request keyed by line key, with the same section
 * re-render Athens does. Rows without companions fall through to Athens untouched. The sync
 * stays as the safety net for any other path (another tab, the mini-cart). */
(function () {
  function patch(CartItems) {
    var original = CartItems.prototype.updateQuantity;

    CartItems.prototype.updateQuantity = function (line, quantity, name) {
      // A change from a field that is not a quantity (the order note, VAT, PO) once reached here
      // with no line and posted /cart/change with the note as the quantity: a 400 (2026-10-01).
      // dc-cart-fields.js now stops those events; this is the second guard.
      if (!/^\d+$/.test(String(line))) return;
      var row = document.getElementById('CartItem-' + line);
      var companions = row && row.dataset.companions;
      if (!row || !row.dataset.key || !companions) return original.call(this, line, quantity, name);

      var q = parseInt(quantity, 10) || 0;
      var updates = {};
      updates[row.dataset.key] = q;
      // "key=unit|key=unit": a line key contains a colon, so '=' and '|' are the separators.
      companions.split('|').forEach(function (pair) {
        var parts = pair.split('=');
        var unit = parseInt(parts[1], 10) || 0;
        if (parts[0] && unit > 0) updates[parts[0]] = q * unit;
      });

      this.enableLoading(line);
      var self = this;
      var sections = this.getSectionsToRender();
      var body = JSON.stringify({
        updates: updates,
        sections: sections.map(function (s) { return s.section; }),
        sections_url: window.location.pathname,
      });

      fetch(window.routes.cart_update_url, Object.assign({}, fetchConfig(), { body: body }))
        .then(function (r) { return r.text(); })
        .then(function (state) {
          var parsed = JSON.parse(state);
          if (parsed.errors) {
            return self.updateSectionContents().then(function () { self.updateLiveRegions(line, parsed.errors); });
          }

          self.classList.toggle('is-empty', parsed.item_count === 0);
          var footer = document.getElementById('main-cart-footer');
          if (footer) footer.classList.toggle('is-empty', parsed.item_count === 0);

          sections.forEach(function (section) {
            var host = document.getElementById(section.id);
            if (!host || !parsed.sections || !parsed.sections[section.section]) return;
            var target = host.querySelector(section.selector) || host;
            target.innerHTML = self.getSectionInnerHTML(parsed.sections[section.section], section.selector);
          });

          self.updateLiveRegions(line, '');

          var item = document.getElementById('CartItem-' + line);
          if (item && name && item.querySelector('[name="' + name + '"]')) item.querySelector('[name="' + name + '"]').focus();

          document.dispatchEvent(new CustomEvent(q === 0 ? 'cart:item-remove' : 'cart:item-quantity-update', {
            detail: { cart: parsed, context: self.eventContext },
          }));
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsed });
          }
        })
        .catch(function () { self.setError(window.cartStrings && window.cartStrings.error); })
        .finally(function () { self.disableLoading(); });
    };
  }

  customElements.whenDefined('cart-items').then(function () {
    patch(customElements.get('cart-items'));
  });
})();
